import * as React from 'react';
import { Icon } from '../icons/Icons';
import { Select, SelectOption, SelectOptionGroup } from '../inputs/Select';
import { TextWithSaveButtonRow, TextWithSaveCancelButton } from '../inputs/_components/SaveCancelOverlayButtonRow';
import { Flex, FlexItem } from './FlexHelpers';
import { EditableInputFadingButton, EditableInputWrapper } from './EditableText';

type EditableSelectProps = {
    ariaLabel: string,
    value: string,
    options: (SelectOption | SelectOptionGroup)[],
    emptyText?: string,
    disabled?: boolean,
    onSave?: (value: string) => void,
    onSaveWithReturnValue?: (value: string) => Promise<boolean>
}

export function EditableSelect (props: EditableSelectProps): JSX.Element
{
    const [inEdit, setInEdit] = React.useState(false);

    const selectedOption = getOptionByValue(props.options, props.value);
    const readOnlyValue = selectedOption?.text ?? props.emptyText ?? '';
    const hideHoverButton = props.disabled === true;

    async function handleChange (value: string)
    {
        if (props.onSaveWithReturnValue)
        {
            const saved = await props.onSaveWithReturnValue(value);
            if (saved)
                setInEdit(false);
            return;
        }

        props.onSave?.(value);
        setInEdit(false);
    }

    return (
        <FlexItem style={{ flexGrow: 1, width: '100%' }}>
            <EditableInputWrapper
                fontSize={16}
                paddingVertical={10}
                paddingHorizontal={15}
                style={{ minHeight: '42px' }}>
                {inEdit &&
                    <div style={{ position: 'relative' }}>
                        <Select
                            selectedValue={props.value}
                            options={props.options}
                            emptyText={props.emptyText}
                            disabled={props.disabled}
                            onChange={handleChange}
                        />
                        <TextWithSaveButtonRow>
                            <TextWithSaveCancelButton
                                onClick={() => setInEdit(false)}
                                aria-label="Annuller">
                                <Icon name="actions_close" size="small" />
                            </TextWithSaveCancelButton>
                        </TextWithSaveButtonRow>
                    </div>
                }
                {!inEdit &&
                    <Flex
                        alignItems="center"
                        onClick={() => !props.disabled && setInEdit(true)}
                        style={{
                            boxSizing: 'border-box',
                            border: '1px solid transparent',
                            height: '42px',
                            padding: '10px 15px'
                        }}>
                        <span aria-label={props.ariaLabel} style={{ border: 'none', lineHeight: '20px', padding: 0 }}>{readOnlyValue}</span>
                        {!hideHoverButton &&
                            <EditableInputFadingButton aria-label={`rediger ${props.ariaLabel}`}>
                                <Icon name="interface_actions_edit" />
                            </EditableInputFadingButton>
                        }
                    </Flex>
                }
            </EditableInputWrapper>
        </FlexItem>
    );
}

function getOptionByValue (options: (SelectOption | SelectOptionGroup)[], value: string): SelectOption | undefined
{
    for (const option of options)
    {
        if ('options' in option)
        {
            const matchingOption = option.options.find(item => item.value === value);
            if (matchingOption)
                return matchingOption;
        }
        else if (option.value === value)
            return option;
    }

    return undefined;
}
